import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

export const permissionMap: Record<string, any> = {
  all_users: { key: 'all_users', color: 'blue' },
  only_me: { key: 'only_me', color: 'green' },
  all_team_members: { key: 'all_team_members', color: 'orange' },
}

const PermissionTag = ({ value }: { value: string | undefined }) => {
  const { t } = useTranslation()
  if (!value) return null
  const config = permissionMap[value]
  return <Tag color={config.color}>{t(`table.permissionTag.${config.key}`)}</Tag>
}

export default PermissionTag
